import React from 'react';

export const Loading = () => (
    <span className="icon is-large">
        <i className="fas fa-2x fa-spinner fa-spin"/>
    </span>
);